module.exports = __webpack_public_path__ + "static/media/mf.1827a83f.svg";